<template>
    <span class="fns pr u-us-n hierarchy-type" style="display: inline-block;">
        <i :class="uiIcon" :title="uiTitle"></i>
        <i v-if="uiShowNoIntegrationsBadge"
            class="lnr-unlinked hierarchy-icon-badge"
            :title="'mead.labels.no_integrations' | athT">
        </i>
    </span>
</template>
<script>
export default {
    name: 'mead-hierarchy-type',
    props: {
        /**
         * Hierarchy node type (e.g. 'ROOT', 'GROUP', 'BRAND') used to determine the displayed icon and title.
         */
        type: {type: String, default: ''},
        /**
         * Whether to show a small "no integrations" badge overlaid on the icon.
         */
        uiShowNoIntegrationsBadge: {type: Boolean, default: () => false},
    },
    computed: {
        uiTitle: function () {
            if (this.type === 'ROOT') {
                return MeadCommon.I18N.go('mead.atom_entity_location_type.company');
            } else if (this.type === 'GROUP') {
                return MeadCommon.I18N.go('mead.atom_entity_location_type.group');
            } else {
                return MeadCommon.I18N.go('mead.atom_entity_location_type.location');
            }
        },
        uiIcon: function () {
            if (this.type === 'ROOT') {
                return 'lnr-apartment';
            } else if (this.type === 'GROUP') {
                return 'lnr-folder';
            } else if (this.type === 'BRAND') {
                return 'lnr-earth';
            } else {
                return 'lnr-store';
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.hierarchy-icon-badge {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.6rem;
    height: 1.6rem;
    font-size: 1.2rem;
    bottom: -.5rem;
    right: -.5rem;
    border-radius: 30%;
}

.lnr-unlinked {
    color: var(--c-txt);
    background-color: var(--c-brand-default-bg);
}
</style>